import { AdjustmentStep } from "../../hooks/useContingencySettings";
import labels from "../../utils/labels";
import {ReactComponent as WarningIcon} from "../../assets/icons/warning_yellow.svg"

const ContingencyStatusBlock = ({
  contingencyLevel,
}: {
  contingencyLevel?: AdjustmentStep;
}) => {
  const adjustmentLabels: Record<AdjustmentStep, string> = {
    SMALL: labels.smallAdjustment,
    MEDIUM: labels.mediumAdjustment,
    LARGE: labels.largeAdjustment,
  };

  const subtitle = contingencyLevel
    ? adjustmentLabels[contingencyLevel]
    : labels.expandedTransportOnly;

  return <div className="flex items-center gap-[--spacing-base]"><WarningIcon/><div> <h4>{labels.contingencyPlanIsActive}</h4>
    <p className="label">{subtitle}</p></div></div>;
};

export default ContingencyStatusBlock;
